// extracted by mini-css-extract-plugin
export default {"menubox":"MenuExternal_menubox__Q+OKK","horizmenu":"MenuExternal_horizmenu__6Enmv"};